import { SlideHeader, Headline, Body } from "../shared";

export function Slide15BigQuestion() {
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-bigquestion">
      <SlideHeader n="16" label="The Big Question" />
      <Headline>
        If the product were already on your wrist,{" "}
        <span className="text-accent">would you use it more often?</span>
      </Headline>
      <Body>
        Better access can drive better adherence. Better adherence gives formulations more
        chances to work, and more use creates value for consumers and brands.
      </Body>
      <div className="mt-5 space-y-3 max-w-xl" data-testid="pitch-bigquestion-callouts">
        <p className="font-body text-base md:text-lg font-medium leading-relaxed" style={{ color: "#ff2d78" }}>
          Today: Only 33% of U.S. adults reapply sunscreen as recommended.
        </p>
        <p className="font-body text-base md:text-lg font-medium leading-relaxed" style={{ color: "#00e5ff" }}>
          This round: A 200-user pilot measures whether wrist access changes behavior.
        </p>
      </div>
    </div>
  );
}
